import React from "react";
import SectionHeadline from "./SectionHeadline";
import img4 from "../assets/hol3.jpg";
import tulsi from "../assets/tulsi.jpg";
import bishow from "../assets/bishow-removebg-preview.png";
import nir from "../assets/nirajan-removebg-preview.png";
import reena from "../assets/reena-removebg-preview.png";
import sabina from "../assets/sabinamam.png";
import tekmaya from "../assets/tekmaya-removebg-preview.png";

const Teams = () => {
  const team = [
    {
      avatar: bishow,
      name: "Bishwa Bandhu Subedi",
      title: "Principal",
    },
    {
      avatar: reena,
      name: "Reena Mool Rajbhandari",
      title: "Vice-Principal",
    },
    {
      avatar: tulsi,
      name: "Tulsi Das Shrestha",
      title: "CEO",
    },
    {
      avatar: nir,
      name: "Mr.Niranjan Bhattarai",
      title: "Examination and Field Co-ordinator, Faculty of General Medicine",
    },
    {
      avatar: sabina,
      name: "Ms.Sabina Shah",
      title: "Pharmacy Co-ordinator",
    },
    {
      avatar: tekmaya,
      name: "Ms.Tek Maya thapa",
      title: "HA Co-ordinator",
    },
  ];

  return (
    <section className=" md:px-0 px-4 flex justify-center items-center">
      <div className=" w-full md:w-10/12">
        <SectionHeadline
          title="  Our Team"
          backgroundImage={img4}
          description=" At Holy Vision Technical Campus (HVTC), our team of experienced
            faculty and educators nurtures future professionals"
        />
        <div className="mt-12">
          <ul className="grid gap-12 sm:grid-cols-2 md:grid-cols-3">
            {team.map((item, idx) => (
              <li key={idx} className=" group">
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1500"
                  className="w-full  h-96"
                >
                  <img
                    src={item.avatar}
                    className="w-full  hover:-translate-y-px px-10 py-2 duration-500 h-full object-cover object-center shadow-md rounded-xl"
                    alt={`${item.name}'s avatar`}
                  />
                </div>
                <div className=" py-2 bg-none group-hover:transform group-hover:translate-y-[-3rem] transition ease-in-out text-center group-hover:bg-primary-450 text-slate-600 duration-500 group-hover:text-white">
                  <h4 className="text-lg group-hover:text-gray-100 text-gray-700 font-semibold">
                    {item.name}
                  </h4>
                  <p className="text-indigo-600 group-hover:text-gray-200">
                    {item.title}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Teams;
